import { inject, Injectable } from '@angular/core';
import { DialogService } from '@core/services/dialog.service';
import { PurchaseSuccessDialogComponent } from './purchase-success-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { DvDialogComponent } from '@devinco/ui/dds';

@Injectable({ providedIn: 'root' })
export class PurchaseSuccessDialogService {
  private dialog = inject(DialogService);
  private translate = inject(TranslateService);

  openPurchaseSuccessDialog(): DvDialogComponent<PurchaseSuccessDialogComponent, undefined> {
    return this.dialog.open({
      title: this.translate.instant('PurchaseSuccessDialog.Title') + ' ❤️',
      contentComponent: PurchaseSuccessDialogComponent,
      confirmText: '',
      size: 'sm',
      hideFooter: true,
    });
  }
}
